import { useState } from "react";
import {
  Configure,
  HierarchicalMenu,
  RangeInput,
  RefinementList,
  SearchBox,
} from "react-instantsearch";
import { BaseFacet, Filter } from "../ca/filter/Facet";
import { config } from "../ca/state/config";
import { KavelChat } from "./KavelChat";

type Tab = "filters" | "chat";

const TabBar = ({ active, onChange }: { active: Tab; onChange: (t: Tab) => void }) => {
  const base = "flex-1 py-1.5 text-xs font-semibold text-center cursor-pointer transition-colors";
  const activeClass = "bg-bright-yellow text-black";
  const inactiveClass = "bg-gray-100 text-gray-500 hover:bg-gray-200";
  return (
    <div className="flex rounded overflow-hidden border border-gray-200 mb-2">
      <button
        className={`${base} ${active === "filters" ? activeClass : inactiveClass}`}
        onClick={() => onChange("filters")}
      >
        Filters
      </button>
      <button
        className={`${base} ${active === "chat" ? activeClass : inactiveClass}`}
        onClick={() => onChange("chat")}
      >
        Chat
      </button>
    </div>
  );
};

const Filters = () => (
  <>
    <div className="border-1 border-gray p-2">
      <SearchBox placeholder="Zoek op adres / kadastraal nummer" />
    </div>
    <div className="border-1 border-gray p-2">
      <p>Provincie/gemeente</p>
      <HierarchicalMenu attributes={["zone_1", "zone_2"]} limit={50} sortBy={["name"]} />
    </div>
    <div className="border-1 border-gray p-2">
      <p>Oppervlakte bebouwd</p>
      <RangeInput attribute="building_area" />
    </div>
    {["land_cover", "built_up_area", "arch_monuments", "nnn", "natura_2000"].map((attr) => (
      <Filter key={attr} label={config.facetMapping[attr]}>
        <RefinementList attribute={attr} />
      </Filter>
    ))}
  </>
);

export const KaFacet = () => {
  const [tab, setTab] = useState<Tab>("filters");
  return (
    <BaseFacet className="fixed mt-14 p-2 sm:w-[20rem] lg:w-[23rem] flex z-10 overflow-y-scroll h-screen bg-white">
      <Configure filters="zone_1:Groningen OR zone_1:Drenthe" />
      <TabBar active={tab} onChange={setTab} />
      <div className={tab === "filters" ? "" : "hidden"}>
        <Filters />
      </div>
      <div className={tab === "chat" ? "flex flex-col flex-1 min-h-0" : "hidden"}>
        <KavelChat />
      </div>
    </BaseFacet>
  );
};
